import React from 'react';
import Root from '@components/Layout';
import MsalAuthProvider from '@components/MsalProvider';
import withStoreAndBrowserRouter from '@components/HOC/withStoreAndRouter';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@api/queryClient';

// withStoreAndBrowserRouter adds application routes through react-router
const EnhancedRoot = withStoreAndBrowserRouter(Root);

interface AppProps {
  msalInstance: PublicClientApplication;
}

// App only renders after authentication is handled in index.tsx
const App: React.FC<AppProps> = ({ msalInstance }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <MsalProvider instance={msalInstance}>
        <MsalAuthProvider>
          <EnhancedRoot />
        </MsalAuthProvider>
      </MsalProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
